import React, { useMemo } from "react";
import "./index.scss";
import TagBox from "devextreme-react/tag-box";
import { IMdaeMdaeTagBoxProps } from "./index";
import {
  DX_WIDGET_NAMES,
  configureMdaeWidgetOptionUpdaters,
} from "../../mdae-framework";
import { useDispatch } from "react-redux";
import { RequiredFieldLabel } from "../required-field-label";
import $ from "jquery";
import MdaeTooltip from "../tooltip";

const MdaeTagBox: React.FC<IMdaeMdaeTagBoxProps> = (props) => {
  const dispatch = useDispatch();
  const tagBoxProps = useMemo(() => {
    return {
      onMultiTagPreparing: (e) => {
        if (typeof props.onMultiTagPreparing === "function")
          props.onMultiTagPreparing(e);

        let maxDisplayedTags = e.component.option("maxDisplayedTags");
        const displayExpr = e.component.option("displayExpr");
        maxDisplayedTags = maxDisplayedTags ? maxDisplayedTags : 1;
        let str = "";
        for (let i = maxDisplayedTags - 1; i < e.selectedItems.length; i++) {
          str = str + e.selectedItems[i][displayExpr] + ", ";
        }
        str = str.substr(0, str.length - 2);
        $(e.multiTagElement).attr("title", str);
      },
      onInitialized: (e) => {
        if (typeof props.onInitialized === "function") props.onInitialized(e);
        configureMdaeWidgetOptionUpdaters(
          props.mdaeDataUpdaterConfig,
          DX_WIDGET_NAMES.DX_SELECT_BOX,
          e.component,
          dispatch
        );
      },
    };
  }, []);
  return (
    <>
      <div className="sys-mdae-tag-box-container">
        <TagBox
          {...props}
          maxDisplayedTags={props.maxDisplayedTags || 1}
          multiline={false}
          showMultiTagOnly={true}
          searchEnabled={true}
          selectAllMode={props?.selectAllMode ? props.selectAllMode :"allPages"}
          {...tagBoxProps}
          dropDownOptions={{
            onShown: (e) => {
              if ((!props.hasAllAuditGroupAccess && props.isAuditGroupWidget)|| props.isFromPaymentRiskTab)
                $(e.component.content())
                  .find(".dx-list-select-all")
                  .hide();
            },
          }}
        />
        {props.visible !== false && (
          <span className={"mdae-text-box-field-set-text"}>
            {props.mdaeTagBoxTitle}
            {props.required && <RequiredFieldLabel />}
          </span>
        )}
      </div>
      {props.isAuditGroupWidget &&
        props.isPageEditMode &&
        !props.hasAllAuditGroupAccess && (
          <MdaeTooltip
            id={""}
            target={"#" + props.readOnlyTooltipContainerId}
            showEvent={"mouseenter"}
            hideEvent={"mouseleave"}
            position={"left"}
            hideOnOutsideClick={false}
            width={250}
          >
            <span className="audit-group-tooltip-text">
              You are not permitted to edit the audit groups for this{" "}
              {props.auditGroupEntityName?.toLowerCase()} because it is linked
              to audit groups to which you do not have access. Contact your
              builder or user manager for additional assistance.
            </span>
          </MdaeTooltip>
        )}
    </>
  );
};
export default MdaeTagBox;
